module.exports = __webpack_public_path__ + "static/media/GalleryHeader3.adc7b1d5.jpg";